/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Video preview documents component
 */

// Dependencies
import PropTypes from 'prop-types';

const VideoViewer = ({ url }) => {
  return (
    <video
      controlsList="nodownload"
      autoPlay={true}
      preload="none"
      className="w-full rounded-lg"
      controls>
      <source src={url} type="video/mp4" />
    </video>
  );
};

/**
 * Component definition of proptypes
 */
VideoViewer.propTypes = {
  url: PropTypes.string.isRequired
};

export default VideoViewer;
